import { styled } from '@mui/material';
import theme from 'theme';

export const Container = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 60,
    paddingBottom: 120,
    paddingLeft: 40,
    paddingRight: 40,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 40,
    },
});

export const InnerContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 1200,
});

export const TitleRow = styled('div')({
    marginBottom: 20,
    textAlign: 'center',
});

export const TwoColumnLayout = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    maxWidth: 1200,
    alignItems: 'stretch',
});

export const SidebarColumn = styled('div')({
    width: 284,
    flexShrink: 0,
});

export const StickyFilters = styled('div')({
    position: 'sticky',
    top: 20,
    paddingRight: 24,
});

export const Divider = styled('div')({
    width: 1,
    backgroundColor: '#d4d4d4',
    flexShrink: 0,
    marginTop: -60,
    marginBottom: -120,
    alignSelf: 'stretch',
});

export const MainColumn = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    paddingLeft: 24,
});

export const MobileFiltersRow = styled('div')({
    marginBottom: 20,
    width: '100%',
});

export const ResultsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
});

export const TeacherList = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
});
